import activityLogRoutes from 'modules/activityLog/common/routing/routes'

const routes = {
  root: `${activityLogRoutes.root}/details/rapid-elearning`,
}

export default routes
